exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deadJWT,\n.unknownJWT {\n  background-image: radial-gradient(circle at 50% -25%, #56585a, #232323);\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n}\n.deadJWT section,\n.unknownJWT section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.deadJWT section cxSpinner,\n.unknownJWT section cxSpinner {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.deadJWT section div,\n.unknownJWT section div {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  margin-left: 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/programming.component.less
// module id = 1408
// module chunks = 2